import { Link } from 'react-router-dom';

/** Catch-all sin redirigir al Resumen (evita “desaparecer” rutas como /lab/*). */
export default function NotFoundPage() {
  return (
    <div className="analytics-module lab-module">
      <header className="analytics-header">
        <div className="analytics-header-copy">
          <p className="analytics-eyebrow">Analytics</p>
          <h1 className="analytics-title">Ruta no encontrada</h1>
          <p className="analytics-subtitle">
            Esta URL no coincide con ninguna pantalla de la app. No te redirigimos al Resumen para
            que puedas corregir el enlace.
          </p>
        </div>
      </header>
      <div className="analytics-panel">
        <p>
          <Link to="/">Ir al Resumen</Link>
          {' · '}
          <Link to="/lab/atencion">Lab · Atención ahora</Link>
        </p>
      </div>
    </div>
  );
}
